export const segmentBlocksIntoSlides = (blocks = [], { includeEmpty = true } = {}) => {
  const slides = [];
  let current = [];
  let nextSlideId = null;

  const pushCurrent = (forceEmpty = false) => {
    if (!current.length && !forceEmpty) return;
    slides.push({ blocks: current, slideId: nextSlideId });
    current = [];
    nextSlideId = null;
  };

  blocks.forEach((block) => {
    const isSlideBreak = block?.type === 'divider' && block?.content?.isSlideBreak === true;
    if (isSlideBreak) {
      if (current.length > 0) {
        pushCurrent();
      } else if (includeEmpty && nextSlideId !== null) {
        pushCurrent(true);
      }
      nextSlideId = block.slideId || block.content?.slideId || null;
      return;
    }

    if (!current.length && nextSlideId === null && (block?.slideId || block?.content?.slideId)) {
      nextSlideId = block.slideId || block.content?.slideId;
    }

    current.push(block);
  });

  if (current.length > 0) {
    pushCurrent();
  } else if (includeEmpty && (slides.length === 0 || nextSlideId !== null)) {
    pushCurrent(true);
  }

  return slides;
};
